import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
              providedIn: 'root'
            })
export class AssistanceEventService {

  onChangeForAssistanceList: Subject<void> = new Subject<void>();

}
